import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    setData: ["payload"],
    updateData: ["payload"],
    updateGroups: ["payload"],
    updateAuth: ["payload"],
    setActiveGroup: ["payload"],
    setBases: ["payload"],
});

const INITIAL_STATE = {
    bases: [],
    sem_base: true,
    grupo_ativo: null,
};

const setData = (state, action) => action.payload;

const updateData = (state = INITIAL_STATE, action) => ({
    ...state,
    ...action.payload,
});

const updateAuth = (state = INITIAL_STATE, action) => ({
    ...state,
    grupos: {
        ...state.grupos,
        ...action.payload.grupos,
    },
    grupo_ativo: action.payload.grupo_ativo,
    bases: action.payload.bases,
});

const updateGroups = (state = INITIAL_STATE, action) => ({
    ...state,
    grupos: {
        ...state.grupos,
        ...action.payload,
    },
});

const setActiveGroup = (state = INITIAL_STATE, action) => ({
    ...state,
    grupo_ativo: action.payload,
});

const setBases = (state = INITIAL_STATE, action) => ({
    ...state,
    bases: action.payload,
});


export default createReducer(INITIAL_STATE, {
    [Types.SET_DATA]: setData,
    [Types.UPDATE_DATA]: updateData,
    [Types.UPDATE_GROUPS]: updateGroups,
    [Types.UPDATE_AUTH]: updateAuth,
    [Types.SET_ACTIVE_GROUP]: setActiveGroup,
    [Types.SET_BASES]: setBases,
});
